export enum FileActionType {
  CREATE_FOLDER = 'CREATE_FOLDER',
  RENAME = 'RENAME',
  CHANGE_TYPE = 'CHANGE_TYPE'
}
